<template>
  <div class="input-group daypickr flex">
    <dtpBtn
      flat
      round
      dense
      icon="chevron_left"
      @click="datepickerDec"
      class="noprint"
    />
    <FlatPickr
      :modelValue="displayDate"
      @on-change="flatdateChanged"
      :config="config"
      placeholder="Select date"
      name="day"
    />
    <dtpBtn
      flat
      round
      dense
      icon="chevron_right"
      @click="datepickerAdd"
      class="noprint"
    />
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { addDays } from "date-fns";
import i18n from "../i18n";
import { getFlatpickrLocale } from "../utils/flatpickrLocale";

defineOptions({ name: "IstToolbarWeek" });

const props = withDefaults(
  defineProps<{ modelValue?: Date | null; disabled?: boolean }>(),
  {
    modelValue: null,
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "change", date: Date): void;
  (e: "input", date: Date): void;
  (e: "update:modelValue", date: Date): void;
}>();

const displayDate = ref<Date>(new Date());
const config = ref<any>({
  week: { weekNumbers: true },
  wrap: true,
  altFormat: i18n.global.t("actualPlan.weekescaped").toString() + " W ",
  altInput: true,
  dateFormat: "d-m-Y",
  weekNumbers: true,
  plugins: [],
  locale: getFlatpickrLocale(),
});

watch(
  () => (i18n.global.locale as unknown as { value: string }).value,
  () => {
    config.value = { ...config.value, locale: getFlatpickrLocale() };
  },
);

onMounted(() => {
  displayDate.value = props.modelValue || new Date();
});

const dateChanged = (date: Date) => {
  emit("change", date);
  emit("input", date);
  emit("update:modelValue", date);
};

const flatdateChanged = (date: Date[]) => {
  dateChanged(date[0]);
};

const datepickerAdd = () => {
  displayDate.value = addDays(props.modelValue || new Date(), 7);
  dateChanged(displayDate.value);
};
const datepickerDec = () => {
  displayDate.value = addDays(props.modelValue || new Date(), -7);
  dateChanged(displayDate.value);
};
</script>
<style lang="scss" scoped>
@import "../assets/variables";

.daypickr {
  :deep(.form-control) {
    color: $ist-blue !important;
    border: none;
    text-align: center;
    cursor: pointer;
    width: 100px;
  }
}
</style>
